<template>

  <div class="blindbox-detail-page">

    <h1 class="page-title">{{ staticDetail.title }}</h1>

    <DetailMain

      :detail="mergedDetail"

      :joining="joining"

      :join-disabled="joinDisabled"

      :join-label="joinLabel"

      @join="onJoin"

    />

    <div class="divider" />

    <ParticipationRecords

      :current-participants="currentParticipants"

      :history-winners="historyWinners"

      :loading="loading"

    />

  </div>

</template>



<script>

import { mapGetters } from "vuex";

import { Notify } from "vant";

import DetailMain from "./components/DetailMain.vue";

import ParticipationRecords from "./components/ParticipationRecords.vue";

import { getBlindBoxDetail } from "./config";

import {

  fetchBlindboxDetail,

  participateInLottery,

} from "@/contract/services/lotteryService";



const POLL_INTERVAL_MS = 20000;



export default {

  name: "BlindboxDetail",

  components: {

    DetailMain,

    ParticipationRecords,

  },

  data() {

    return {

      loading: false,

      joining: false,

      chainData: null,

      pollTimer: null,

    };

  },

  computed: {

    ...mapGetters(["accountAddress"]),

    frontendId() {

      return Number(this.$route.params.id);

    },

    staticDetail() {

      return getBlindBoxDetail(this.frontendId);

    },

    mergedDetail() {

      if (!this.staticDetail) {

        return null;

      }

      return {
        ...this.staticDetail,
        remaining: this.chainData?.remaining ?? 0,
        participantCount: this.chainData?.participantCount ?? 0,
      };

    },

    currentParticipants() {

      return (this.chainData?.participants || []).map((item) => item.display);

    },

    historyWinners() {

      return (this.chainData?.historyWinners || []).map((item) => item.display);

    },

    joinDisabled() {

      if (!this.accountAddress || this.joining || this.loading) {

        return true;

      }

      if (!this.chainData) {

        return true;

      }

      if (!this.chainData.hasStock) {

        return true;

      }

      if (this.chainData.isRoomFull) {

        return true;

      }

      if (this.chainData.hasJoined) {

        return true;

      }

      return false;

    },

    joinLabel() {

      if (!this.accountAddress) {

        return "请先连接钱包";

      }

      if (!this.chainData) {

        return "加载中...";

      }

      if (!this.chainData.hasStock) {

        return "暂无可用卡牌";

      }

      if (this.chainData.hasJoined) {

        return "已参与当前局";

      }

      if (this.chainData.isRoomFull) {

        return "当前房间已满";

      }

      if (this.joining) {

        return "提交中...";

      }

      return "立即参与";

    },

  },

  watch: {

    staticDetail: {

      immediate: true,

      handler(value) {

        if (!value) {

          this.$router.replace("/home");

        }

      },

    },

    frontendId: {

      immediate: true,

      handler() {

        this.loadChainData();

        this.startPolling();

      },

    },

    accountAddress() {

      this.loadChainData();

    },

  },

  beforeDestroy() {

    this.stopPolling();

  },

  methods: {

    startPolling() {

      this.stopPolling();

      this.pollTimer = setInterval(() => {

        this.loadChainData({ silent: true }).catch(() => {});

      }, POLL_INTERVAL_MS);

    },

    stopPolling() {

      if (this.pollTimer) {

        clearInterval(this.pollTimer);

        this.pollTimer = null;

      }

    },

    async loadChainData({ silent = false } = {}) {

      if (!this.staticDetail) {

        return;

      }

      if (!silent) {

        this.loading = true;

      }

      try {

        this.chainData = await fetchBlindboxDetail(this.frontendId);

      } catch (err) {

        if (!silent) {

          Notify({

            type: "danger",

            message: err?.message || "加载盲盒数据失败",

          });

        }

        throw err;

      } finally {

        if (!silent) {

          this.loading = false;

        }

      }

    },

    async onJoin() {

      if (this.joinDisabled) {

        if (!this.accountAddress) {

          Notify({ type: "warning", message: "请先连接钱包" });

        }

        return;

      }



      this.joining = true;

      try {

        await participateInLottery(this.frontendId);

        Notify({ type: "success", message: "参与成功" });

        await this.loadChainData();

      } catch (err) {

        //

      } finally {

        this.joining = false;

      }

    },

  },

};

</script>



<style lang="scss" scoped>

.blindbox-detail-page {

  min-height: 100%;

  padding-bottom: 20px;

}



.page-title {

  margin: 0;

  padding: 16px 30px 20px;

  font-size: 34px;

  color: #fff;

}



.divider {

  margin: 28px 30px;

  height: 1px;

  background: rgba(255, 255, 255, 0.12);

}

</style>


